import { BehaviorSubject } from 'rxjs';
import jwt_decode from "jwt-decode";
import { handleResponse } from '../helpers/handle-response';
import { get, post } from 'src/services/httpClient.service';

let initialUser = null;

if (localStorage.getItem('token') && localStorage.getItem('token')!=null) {
    try {
        // scheduleTokenRefresh();
        // console.info("Schedular Started.")
        initialUser = jwt_decode(localStorage.getItem('token'));
    } catch (error) {
        console.error("Error decoding token:", error['message']);
        redirectToLogin();
    }
}

let currentUserSubject = new BehaviorSubject(initialUser);

export const authenticationService = {
    login,
    logout,
    isAllowed,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() { return currentUserSubject.value },
    scheduleTokenRefresh,
    redirectToLogin,
    getRefreshToken,
    getVendorFranchisePath,
    getVendorFranchiseIds,
    getSelectedLCO
};

async function login(credentials) {
    try {
        let resp = await fetch(process.env.REACT_APP_API_URL + process.env.REACT_APP_USER_LOGIN, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(credentials)
        }).then(handleResponse)
            .then(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('token', user.token);
                currentUserSubject.next(user);
                return user;
            });
        return resp;
    } catch (error) {
        console.error("Login error:", error);
        throw error; // Rethrow the error for handling in the component or caller
    }
}

function logout() {
    // remove user from local storage to log the user out
    localStorage.removeItem('token');
    localStorage.clear();
    currentUserSubject.next(null);
}

function isAllowed(allowed_roles) {
    let currentuser = authenticationService.currentUserValue;
    return (currentuser && currentuser.user && currentuser.user.roles && currentuser.user.roles.some(ai => allowed_roles.includes(ai))) ? true : false;
}

function redirectToLogin() {
    localStorage.removeItem('token');
    localStorage.removeItem('login');
    localStorage.removeItem('user');
    window.location.assign("/login");
    //window.location.href = "/login"; // change this path based on your route setup
};

//--- sending refresh token before expiry in 2 mins
function scheduleTokenRefresh() {
  //console.log("Started")
  const token = localStorage.getItem("token");
  //console.log(token)
  if (!token) return;
    console.log("Available")
  try {
    const decoded = jwt_decode(token);
    const expiresAt = decoded.exp * 1000; // ms
    const now = Date.now();
    const refreshBefore = 2 * 60 * 1000;

    let delay = expiresAt - now - refreshBefore;
    //console.log(delay)
    if (delay < 0) delay = 0; // trigger immediately if already close
    // 🕑 Debug log
    const refreshTime = new Date(now + delay).toLocaleString();
    console.log(
      `⏳ Token refresh scheduled in ${delay} ms (~${Math.round(
        delay / 1000
      )} sec) at ${refreshTime}`
    );
    setTimeout(async () => {
      const newToken = await getRefreshToken();
      if (newToken!=null) scheduleTokenRefresh(); // only re-schedule on success
    }, delay);
  } catch (error) {
    console.error("Error scheduling refresh:", error);
    redirectToLogin();
  }
}


async function getRefreshToken() {
  try {
    const token = localStorage.getItem("token");
    let {vendorId, franchiseId, companyId, operatorId} = getVendorFranchiseIds();
    const data = await get(`${process.env.REACT_APP_BASE_API_URL}/api/auth/refresh-token/OPERATOR`, { params: {userId: operatorId} });
    console.log("Refresh Token :::", data?.accessToken);

    if (data && data.accessToken) {
      const decoded = jwt_decode(data.accessToken);
      const currentTime = Math.floor(Date.now() / 1000); // in seconds

      // Save the new token
      localStorage.setItem("token", data.accessToken);
      localStorage.setItem("login", "true");
      localStorage.setItem("user", JSON.stringify(decoded));

      console.log("decoded.exp:", decoded.exp);
      console.log("currentTime:", currentTime);

      // If the new token is already expired or expiring instantly → logout
      if (decoded.exp <= currentTime) {
        console.warn("Refreshed token is already expired!");
        redirectToLogin();
      }

      return data.accessToken; // ✅ return new token
    } else {
      console.error("No accessToken received in refresh response");
      redirectToLogin();
    }
  } catch (error) {
    console.error("Error refreshing token:", error);
    redirectToLogin();
  }
}

//---------- Sending token after expiry
/*
function scheduleTokenRefresh() {
  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    const decoded = jwt_decode(token);
    const expiresAt = decoded.exp * 1000; // expiry in ms
    const now = Date.now();
    const delay = expiresAt - now + 1000; // refresh 1 sec after expiry

    if (delay <= 0) {
      // already expired → refresh immediately
      getRefreshToken().then(scheduleTokenRefresh);
    } else {
      // schedule refresh after expiry
      //redirectToLogin();
      setTimeout(async () => {
        await getRefreshToken();
        scheduleTokenRefresh(); // reschedule with new token
      }, delay);
    }
  } catch (error) {
    console.error("Error scheduling refresh:", error);
    redirectToLogin();
  }
}


async function getRefreshToken() {
    const data = await post(`${process.env.REACT_APP_BASE_API_URL}/api/auth/refresh-token`, null);
    console.log("Refresh Token ::: "+data.accessToken)
    if (data.accessToken && data.accessToken!=null && data.accessToken!="") {
    
        const decoded = jwt_decode(data.accessToken);
        const currentTime = Date.now() / 1000;

        localStorage.setItem('token', data.accessToken);
        localStorage.setItem('login', 'true');
        localStorage.setItem('user', JSON.stringify(decoded));
        
        console.log('decoded',decoded.exp)
        console.log('currentTime',currentTime)

        if ( decoded.exp < currentTime) {
            redirectToLogin();
        }
    } else {
        redirectToLogin();
    }
}
*/

function getVendorFranchisePath() {
    let userDetails = localStorage.getItem('user')
    let urlPath = "/";
    if(userDetails!=null && userDetails!=undefined) {
        let parsedUser = JSON.parse(userDetails);
        const vendorId = (parsedUser['vendorId']!=null && parsedUser['vendorId']!=undefined)? parsedUser['vendorId'] : null;
        const franchiseId = (parsedUser['franchiseId']!=null && parsedUser['franchiseId']!=undefined)? parsedUser['franchiseId'] : null;

        if(vendorId!=null) {
            urlPath += "vendor/"+vendorId+"/";
        }
        if(franchiseId!=null) {
            //urlPath += "franchise/"+franchiseId+"/";
        }
    }
    return urlPath;
}

function getVendorFranchiseIds() {
    // console.log("======================");
    // console.log("Vendor Details Service");
    let token = localStorage.getItem('token')
    let userDetails = localStorage.getItem('user')
    let operatorDetails = localStorage.getItem('operatorData')
    let selectedFranchise = localStorage.getItem('selectedFranchise');
    let vendorId = null;
    let franchiseId = null;
    let companyId = null;
    let operatorId = null;
    //console.log("userDetails:::", userDetails);
    if(userDetails!=null && userDetails!=undefined) {
        let parsedUser = JSON.parse(userDetails);
        //console.log("parsedUser:::", parsedUser);
        vendorId = (parsedUser['vendorId']!=null && parsedUser['vendorId']!=undefined)? parsedUser['vendorId'] : null;
    }

    if(operatorDetails!=null && operatorDetails!=undefined) {
        let parsedOperator = JSON.parse(operatorDetails);
        companyId = (parsedOperator['companyId']!=null && parsedOperator['companyId']!=undefined)? parsedOperator['companyId'] : null;
        operatorId = (parsedOperator['id']!=null && parsedOperator['id']!=undefined)? parsedOperator['id'] : null;
    }

    // if(selectedFranchise!=null && selectedFranchise!=undefined) {
    //     let parsedFranchise = JSON.parse(selectedFranchise);
    //     franchiseId = (parsedFranchise['id']!=null && parsedFranchise['id']!=undefined)? parsedFranchise['id'] : null;
    // }

      if (selectedFranchise) {
          const parsedFranchise = JSON.parse(selectedFranchise);

          if (parsedFranchise) {
              franchiseId = parsedFranchise?.id ?? null;
          }
      }
    // console.log("VendorId::", vendorId);
    // console.log("FranchiseId::", franchiseId);
    // console.log("CompanyId::", companyId);
    // console.log("OperatorId::", operatorId);
    // console.log("======================");
    return {vendorId, franchiseId, companyId, operatorId};
}

function getSelectedLCO() {
  const accountType = localStorage.getItem('accountType');
  let loggedInData = null;
  if(accountType === 'DISTRIBUTOR') {
    loggedInData = JSON.parse(localStorage.getItem("selectedLCO"));
    console.log("DISTRIBUTOR::"+loggedInData?.id)
  } else if(accountType === 'LCO') {
    loggedInData = JSON.parse(localStorage.getItem("operatorData"));
    console.log("LCO ID::"+loggedInData?.id)
  }
  let selectedLCOId = loggedInData?.id;
  let selectedLCOName = loggedInData?.operatorName;
  let selectedLCOFranchiseId = loggedInData?.franchiseId;
  return { selectedLCOId, selectedLCOName, selectedLCOFranchiseId };
}

